
define('tpl!taoQtiItem/qtiCreator/editor/blockAdder/tpl/addColumnRow', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  


  return "<div class=\"add-block-element\">\n    <div class=\"line\"></div>\n    <div class=\"circle\" title=\"Insert block below\"><span>+</span></div>\n</div>";
  });
});

